import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./containers/Root";
import registerServiceWorker from "./registerServiceWorker";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import createHistory from "history/createBrowserHistory";
import { routerMiddleware } from "react-router-redux";
import { rootSaga } from "./sagas/sagas";
import reducers from "./reducers/reducers";
import { reactReduxFirebase, getFirebase } from "react-redux-firebase";
import initFirebaseAuth from "./firebaseAuth";
import * as firebase from "firebase";
import store from "store";

function initMyApp() {
    const history = createHistory();
    const sagaMiddleware = createSagaMiddleware();

    const firebaseConfig = {
        apiKey: process.env.REACT_APP_API_KEY,
        authDomain: process.env.REACT_APP_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_PROJECT_ID,
        databaseURL: process.env.REACT_APP_DATABASE_URL,
        storageBucket: process.env.REACT_APP_STORAGE_BUCKET
    };
    firebase.initializeApp(firebaseConfig);

    const newCreateStore = compose()(createStore);

    const store = newCreateStore(
        reducers,
        compose(
            reactReduxFirebase(firebase, { userProfile: "users" }),
            applyMiddleware(sagaMiddleware, routerMiddleware(history))
        )
    );

    sagaMiddleware.run(rootSaga, getFirebase);

    initFirebaseAuth(store.dispatch);
    ReactDOM.render(
        <Root history={history} store={store} />,
        document.getElementById("root")
    );
    registerServiceWorker();
}

if (
    window.history &&
    window.location.hash &&
    window.location.hash.startsWith("#!")
) {
    // Redirects from s3 buckets start with #!
    window.history.pushState(
        {},
        "entry page",
        window.location.hash.substring(2)
    );
} else if (
    window.history &&
    window.location.pathname === "/" &&
    store.get("hasLoggedIn")
) {
    // If a user has logged in before, redirect to the /feed page
    window.history.pushState({}, "entry page", "/feed");
}

if (window.Raven) {
    window.Raven
        .config("https://b920740c64684126b90b1518dadd3f99@sentry.io/273654")
        .install();
    window.Raven.context(function() {
        initMyApp();
    });
} else {
    initMyApp();
}



// WEBPACK FOOTER //
// ./src/index.js